import { lazy } from 'react';
import { registerModuleRoute } from 'app/navigation/routeRegistry';
import type { ModuleRoute } from 'app/navigation/routeRegistry';
import { DOCUMENTS_SCREEN_NAMES } from './constants';
import { DocumentsTabIcon } from './components';

const DocumentsNavigation = lazy(() => import('./navigation/DocumentsNavigation'));

const documentsRoutes: ModuleRoute = {
    id: 'documents',
    Stack: DocumentsNavigation,
    meta: {
        placement: 'tab',
        tabLabel: 'Documenti',
        tabIcon: DocumentsTabIcon,
        order: 25,
    },
    screenNames: DOCUMENTS_SCREEN_NAMES,
};

registerModuleRoute(documentsRoutes);
